export const INICIALITZAR = "INICIALITZAR";
export const ESBORRAR_VALORS = "ESBORRAR_VALORS";
export const OBTENIR_OBSERVADORS = "OBTENIR_OBSERVADORS";
export const ESBORRAR_OBSERVADOR_SELECCIONAT =
  "ESBORRAR_OBSERVADOR_SELECCIONAT";
export const ESBORRAR_COMENTARIS = "ESBORRAR_COMENTARIS";
export const OBTENIR_OBSERVADORS_LLISTAT = "OBTENIR_OBSERVADORS_LLISTAT";
export const OBTENIR_OBSERVADORS_ESPECIES = "OBTENIR_OBSERVADORS_ESPECIES";
export const OBTENIR_OBSERVADOR_ID = "OBTENIR_OBSERVADOR_ID";
export const OBTENIR_DADES_OBSERVADOR = "OBTENIR_DADES_OBSERVADOR";
export const OBSERVADOR_INTRODUCCIO_OMPLIR_DADES =
  "OBSERVADOR_INTRODUCCIO_OMPLIR_DADES";
export const OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP =
  "OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP";
export const OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS =
  "OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS";
export const OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS =
  "OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS";
export const OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA =
  "OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA";
export const OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS =
  "OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS";
export const OBSERVADOR_INICIALITZAR = "OBSERVADOR_INICIALITZAR";
export const OBTENIR_INDRETS = "OBTENIR_INDRETS";
export const OBTENIR_INDRET_ID = "OBTENIR_INDRET_ID";
export const OBTENIR_INDRETS_LLISTAT = "OBTENIR_INDRETS_LLISTAT";
export const ESBORRAR_INDRET_SELECCIONAT = "ESBORRAR_INDRET_SELECCIONAT";
export const OBTENIR_DADES_INDRET = "OBTENIR_DADES_INDRET";
export const OBTENIR_INDIVIDU_ID = "OBTENIR_INDIVIDU_ID";
export const OBTENIR_INDIVIDUS_LLISTAT = "OBTENIR_INDIVIDUS_LLISTAT";
export const ESBORRAR_INDIVIDU_SELECCIONAT = "ESBORRAR_INDIVIDU_SELECCIONAT";
export const OBTENIR_DADES_INDIVIDU = "OBTENIR_DADES_INDIVIDU";
export const OBTENIR_DADES_CREACIO_INDIVIDU = "OBTENIR_DADES_CREACIO_INDIVIDU";
export const INDIVIDU_INICIALITZAR = "INDIVIDU_INICIALITZAR";
export const INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP =
  "INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP";
export const INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS =
  "INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS";
export const INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS =
  "INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS";
export const INDIVIDU_INTRODUCCIO_OMPLIR_DADES =
  "INDIVIDU_INTRODUCCIO_OMPLIR_DADES";
export const INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA =
  "INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA";
export const INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS =
  "INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS";
export const INDRET_INICIALITZAR = "INDRET_INICIALITZAR";
export const INDRET_INTRODUCCIO_MODIFICAR_CAMP =
  "INDRET_INTRODUCCIO_MODIFICAR_CAMP";
export const INDRET_INTRODUCCIO_DESCARTAR_CANVIS =
  "INDRET_INTRODUCCIO_DESCARTAR_CANVIS";
export const INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS =
  "INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS";
export const INDRET_INTRODUCCIO_OMPLIR_DADES =
  "INDRET_INTRODUCCIO_OMPLIR_DADES";
export const INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA =
  "INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA";
export const INDRET_INTRODUCCIO_MOSTRAR_ERRORS =
  "INDRET_INTRODUCCIO_MOSTRAR_ERRORS";
export const INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO =
  "INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO";
export const INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO =
  "INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO";
export const INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO =
  "INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO";
export const OBTENIR_MUNICIPIS = "OBTENIR_MUNICIPIS";
export const OMPLIR_USUARI_AUTENTICAT = "OMPLIR_USUARI_AUTENTICAT";
export const INTRODUCCIO_OMPLIR_DATA = "INTRODUCCIO_OMPLIR_DATA";
export const INTRODUCCIO_OMPLIR_ID_OBSERVADOR =
  "INTRODUCCIO_OMPLIR_ID_OBSERVADOR";
export const INTRODUCCIO_OBTENIR_DADES = "INTRODUCCIO_OBTENIR_DADES";
export const INTRODUCCIO_INICIALITZAR = "INTRODUCCIO_INICIALITZAR";
export const INTRODUCCIO_DESCARTAR_CANVIS = "INTRODUCCIO_DESCARTAR_CANVIS";
export const OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI =
  "OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI";
export const INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_EN_CURS =
  "INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_EN_CURS";
export const INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA =
  "INTRODUCCIO_ESBORRAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA";
export const INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_EN_CURS =
  "INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_EN_CURS";
export const INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA =
  "INTRODUCCIO_CREAR_FOTO_FENOFASE_INDIVIDU_FINALITZADA";
export const INTRODUCCIO_OMPLIR_ID_ESPECIE = "INTRODUCCIO_OMPLIR_ID_ESPECIE";
export const INTRODUCCIO_SHOW_COMMENT = "INTRODUCCIO_SHOW_COMMENT";
export const VISUALITZACIO_INICIALITZAR = "VISUALITZACIO_INICIALITZAR";
export const VISUALITZACIO_OBTENIR_DADES = "VISUALITZACIO_OBTENIR_DADES";
export const VISUALITZACIO_OMPLIR_ID_ESPECIE =
  "VISUALITZACIO_OMPLIR_ID_ESPECIE";
export const VISUALITZACIO_OMPLIR_ID_FENOFASE =
  "VISUALITZACIO_OMPLIR_ID_FENOFASE";
export const VISUALITZACIO_OBTENIR_OBSERVACIONS =
  "VISUALITZACIO_OBTENIR_OBSERVACIONS";
export const VISUALITZACIO_OMPLIR_DATA_INICI =
  "VISUALITZACIO_OMPLIR_DATA_INICI";
export const VISUALITZACIO_OMPLIR_DATA_SELECCIONADA =
  "VISUALITZACIO_OMPLIR_DATA_SELECCIONADA";
export const VISUALITZACIO_OMPLIR_DATA_FI = "VISUALITZACIO_OMPLIR_DATA_FI";
export const VISUALITZACIO_SELECCIO_TIPUS = "VISUALITZACIO_SELECCIO_TIPUS";
export const VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA =
  "VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA";
export const SWITCH_MENU_VISIALITZAR_OBSERVACIONS =
  "SWITCH_MENU_VISIALITZAR_OBSERVACIONS";
export const SWITCH_VISIBILITAT_MENU = "SWITCH_VISIBILITAT_MENU";
export const ERROR_CONSULTA_SERVIDOR = "ERROR_CONSULTA_SERVIDOR";
export const OMPLIR_TITOL_APARTAT = "OMPLIR_TITOL_APARTAT";
export const SWITCH_MENU_GENERAL = "SWITCH_MENU_GENERAL";
export const OBTENIR_LLISTAT_CLASSES = "OBTENIR_LLISTAT_CLASSES";
export const CANVI_TEXT_CERCA_VISTA = "CANVI_TEXT_CERCA_VISTA";
export const OBTENIR_RESUM_OBSERVADOR = "OBTENIR_RESUM_OBSERVADOR";
